import './wallet.css'
import React, {useEffect, useRef, useState} from "react";
import {ethers} from "ethers";
import {
    arbitrumCurrent, exchangeContractAbi,
    exchangeContractAddress, marketContractAbi, marketContractAddress,
    tokenContractAbi, tokenContractAddress,
    usdtContractAbi,
    usdtContractAddress,
    switchToArbitrum
} from "../../helpers/contracts";
import {Button, Col, Modal, Row} from "react-bootstrap";
import {CopyToClipboard} from "react-copy-to-clipboard";
import Toast from "react-bootstrap/Toast";
import Form from "react-bootstrap/Form";
import {Grid} from "react-loader-spinner";


function Wallet(props) {
    const [sttBalance, setSttBalance] = useState(0)
    const [usdtBalance, setUsdtBalance] = useState(0)
    const [etcBalance, setEthBalance] = useState(0)
    const [helpUsdtBalance, setHelpUsdtBalance] = useState(0)
    const [showWwModal, setWwModal] = useState(false)
    const [showSendModal, setShowSendModal] = useState(false)
    const [copied, setCopied] = useState(false)
    const [targetErc, setTargetErc] = useState('')
    const [targetAmount, setTargetAmount] = useState(0)
    const [maxValue, setMaxValue] = useState(0)
    const [preloader, setPreloader] = useState({display: 'none'})
    const [toastCompleteShow, setToastCompleteShow] = useState(false)
    const inputRef = useRef(null);

    const handleRateChange = (e) => {
        const input = e.target;
        const value = input.value;

        // Разрешаем цифры, точку и запятую (для дробных чисел)
        const cleanValue = value.replace(/[^0-9.,]/g, '');

        // Заменяем запятую на точку для единообразия
        const normalizedValue = cleanValue.replace(',', '.');

        setTargetAmount(normalizedValue);

        // Обновляем отображение только если значение изменилось
        if (value !== (normalizedValue ? normalizedValue + ' STT' : '')) {
            input.value = normalizedValue ? normalizedValue + ' STT' : '';
        }

        // Сохраняем позицию курсора относительно начала ввода (без учёта %)
        const cursorPosition = input.selectionStart;
        const maxCursorPosition = normalizedValue.length;

        // Устанавливаем курсор, избегая позиции после %
        input.setSelectionRange(
            Math.min(cursorPosition, maxCursorPosition),
            Math.min(cursorPosition, maxCursorPosition)
        );
    };

    // Обработчик фокуса: убираем % при фокусе для удобства редактирования
    const handleFocus = (e) => {
        e.target.value = targetAmount;
    };

    // Обработчик размытия: возвращаем % при потере фокуса
    const handleBlur = (e) => {
        e.target.value = targetAmount ? targetAmount + ' STT' : '';
    };

    function numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    }

    useEffect(() => {
        if (props.account) {
            const acc = props.account
            const provider_balance = new ethers.BrowserProvider(window.ethereum)
            const contract = new ethers.Contract(tokenContractAddress, tokenContractAbi, provider_balance);
            const usdtContract = new ethers.Contract(usdtContractAddress, usdtContractAbi, provider_balance);
            let totalSt = 0.0
            let totalUs = 0.0
            contract.totalSupply().then(res => {
                totalSt = (Number(res) / Math.pow(10, 9)).toFixed(2)
                usdtContract.balanceOf(exchangeContractAddress).then(res => {
                    totalUs = (Number(res) / Math.pow(10, 6)).toFixed(2)
                    contract.balanceOf(acc).then(res => {
                        let stBalance = (parseFloat((Number(res) / Math.pow(10, 9)) - 0.01).toFixed(2))
                        if (stBalance < 0) {
                            stBalance = 0.0
                        }
                        let rate = totalUs / totalSt
                        let usBalance = (parseInt(parseFloat((rate * stBalance)) * 100) /100)
                        setSttBalance(stBalance)
                        setMaxValue(stBalance)
                        setHelpUsdtBalance(usBalance)

                    })
                })
            })
            usdtContract.balanceOf(acc).then(res => {
                let walletUsdtBalance = (parseInt(parseFloat(Number(res) / Math.pow(10, 6)) * 100) / 100).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ').replace('.', ',')
                setUsdtBalance(walletUsdtBalance)
            })
            provider_balance.getBalance(acc).then((balance) => {
                const balanceInEth = parseFloat(ethers.formatEther(balance)).toFixed(5).toString().replace('.', ',')
                setEthBalance(balanceInEth)
            })
        }
    }, [props.account]);

    function validateAndConvertToChecksum(address) {
        // Remove '0x' prefix if present
        const cleanAddress = address.replace(/^0x/i, '');

        // Validate length and characters
        if (!/^[0-9a-fA-F]{40}$/.test(cleanAddress)) {
            throw new Error('Invalid Ethereum address format');
        }

        // Convert to lowercase for checksum calculation
        const lowerCaseAddress = cleanAddress.toLowerCase();

        // Get the keccak‑256 hash of the address
        const hash = ethers.keccak256(ethers.toUtf8Bytes(lowerCaseAddress)).replace('0x', '');

        let checksumAddress = '0x';
        for (let i = 0; i < lowerCaseAddress.length; i++) {
            // If the ith digit of the hash is greater than 7, uppercase the ith digit in the address
            if (parseInt(hash[i], 16) > 7) {
                checksumAddress += lowerCaseAddress[i].toUpperCase();
            } else {
                checksumAddress += lowerCaseAddress[i];
            }
        }
        return checksumAddress;
    }

    const handleSend = () => {
        if (window.ethereum) {
            if (targetAmount > 1) {
                setPreloader({display: 'flex'})
                window.ethereum.request({method: "eth_chainId"}).then((result) => {
                    if (parseInt(result) === 42161) {
                        const provider_balance = new ethers.BrowserProvider(window.ethereum)
                        provider_balance.listAccounts().then(async (result) => {
                            const signer = await provider_balance.getSigner()
                            const marketContract = new ethers.Contract(marketContractAddress, marketContractAbi, signer)
                            const SttContract = new ethers.Contract(tokenContractAddress, tokenContractAbi, signer)
                            let amount = (targetAmount * Math.pow(10,9)).toString().toLocaleString()
                            SttContract.approve(marketContractAddress, amount.toString()).then((res) => {
                                setTimeout(function (){
                                    const checksumAddress = validateAndConvertToChecksum(targetErc)
                                    marketContract.paymentToTheShop(checksumAddress, amount.toString()).then(() => {
                                        setPreloader({display: 'none'})
                                        setTimeout(() => {
                                            setToastCompleteShow(true)
                                            setTargetErc('')
                                            setTargetAmount()
                                            setShowSendModal(false)
                                        }, 100)
                                    }).catch((error) => {
                                        setPreloader({display: 'none'})
                                        console.log(error)
                                    });
                                }, 1500)
                            }).catch((error) => {
                                setPreloader({display: 'none'})
                                console.log(error)
                            });
                        })
                    } else {
                        switchToArbitrum()
                    }
                })
            }
        }
    }

    return (
        <React.Fragment>
            <div className={"wallet_card eth-card"}>
                <div className={"wallet_card-stripe"}>
                    <span>{props.account ? '****' + props.account.substr(props.account.length - 4) : ''}</span>
                    {props.account
                        && <CopyToClipboard text={props.account} onCopy={() => setCopied(true)}>
                            <span style={{fontSize: 24, marginRight: 5, cursor: 'pointer'}}><i className="fa-regular fa-copy"></i></span>
                           </CopyToClipboard>
                    }
                </div>
                {props.account
                    ? <a className={"wallet_card-balance"} href={"https://arbiscan.io/address/" + props.account} target={"_blank"} rel={"noreferrer"}><span className={"stt-empty"}></span><span className={"stt-balance"}>{numberWithCommas(sttBalance)}</span><span className={"stt-arrow"}><img src={"/img/arrow-dark.png"} alt={''} style={{width: 35}} /></span></a>
                    : <React.Fragment><a className={"wallet_card-balance"} href={"#!"} onClick={() => setWwModal(true)}><span className={"stt-empty"}></span><span
                        className={"stt-balance"}>0.0</span><span className={"stt-arrow"}><img
                        src={"/img/arrow-dark.png"} alt={''} style={{width: 35}}/></span></a>
                        <Modal size="sm" show={showWwModal} onHide={() => setWwModal(false)} aria-labelledby="info-mod-title" className={"pre-form-modal telegram-modal"} centered >
                            <Modal.Body>
                                <div className={"stt_modal_header"}>


                                </div>
                                <div className={"help-wrapper telegram-wrapper"} style={{paddingLeft: 0, paddingRight: 0}}>
                                    <img src={"/img/lock.png"} alt={''} style={{width: 80, marginTop: 70}} />
                                    <p style={{fontSize: '1.1rem', marginBottom: 20, marginTop: 30, color: '#888888'}}>Authorization</p>
                                    <p style={{fontSize: '.8rem', marginTop: 0, fontWeight: 400, marginBottom: 25}}>To use full functionality, login to the<br/>website with the browser of your crypto<br/>wallet</p>
                                    <a href={"/login.pdf"} target={"_blank"} rel={"noreferrer"} style={{fontSize: '.8rem', marginTop: 0, fontWeight: 500, display: "block", marginBottom: 45, color: '#47c999'}}>Instructions</a>

                                    <Button className="modal-button"  onClick={() => setWwModal(false)}>Ok</Button>
                                </div>
                            </Modal.Body>
                        </Modal>
                    </React.Fragment>
                }
                <p className={"help-usdt-balance"} >~ {numberWithCommas(helpUsdtBalance)} USDT</p>
                <div style={{
                    display: 'flex',
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}>
                    <div className={"additional-balances"} style={{ width: '50%', marginTop: 0 }}>
                        <div style={{ minWidth: 130, backgroundColor: 'transparent', color: '#000', marginBottom: 0, paddingBottom: 0, fontSize: 11 }}><span>USDT</span> {numberWithCommas(usdtBalance)}</div>
                        <div style={{ minWidth: 130, backgroundColor: 'transparent', color: '#000', marginBottom: 0, paddingTop: 0, fontSize: 11 }}><span>ETH</span> {etcBalance}</div>
                    </div>
                    <Button className="modal-button"  onClick={() => setShowSendModal(true)} style={{
                        width: 150,
                        height: 70,
                        borderRadius: 35,
                        fontWeight: 600,
                        backgroundColor: "rgba(255, 255, 255, 0.6)",
                        color: "#008279",
                        borderColor: "transparent",
                        marginRight: 25
                    }}>Send</Button>
                </div>
            </div>
            {/*<Row>*/}
            {/*    /!*<Col xs={4}>*!/*/}
            {/*    /!*    <a className={"wallet_link  eth-card"} href={"https://t.me/P2PSTT"} target={"_blank"} rel={"noreferrer"}>*!/*/}
            {/*    /!*        <span>P2P</span>*!/*/}
            {/*    /!*        <span><img src={"/img/arrow-dark.png"} alt={''} style={{width: 35}} /></span>*!/*/}
            {/*    /!*    </a>*!/*/}
            {/*    /!*</Col>*!/*/}
            {/*    <Col xs={12}>*/}
            {/*        <a className={"wallet_link  eth-card"} href={"https://t.me/ntpay_exchange_bot"} target={"_blank"} rel={"noreferrer"}>*/}
            {/*            <span>Swap bot</span>*/}
            {/*            <span><img src={"/img/arrow-dark.png"} alt={''} style={{width: 35}} /></span>*/}
            {/*        </a>*/}
            {/*    </Col>*/}
            {/*</Row>*/}
            <div className={"preloader"} style={preloader}>
                <Grid
                    height="80"
                    width="80"
                    color="#ffffff"
                    ariaLabel="grid-loading"
                    radius="12.5"
                    wrapperStyle={{}}
                    wrapperClass=""
                    visible={true}
                />
            </div>
            <Toast onClose={() => setCopied(false)} show={copied} onClick={() => setCopied(false)} position={"middle-center"} autohide delay={3000} className={"complete-toast"} style={{position: "fixed"}}>
                <Toast.Body>
                    <i className="fa-solid fa-circle-check" style={{fontSize: '6rem', margin: 20, color: '#96fac5'}}></i>
                    <p style={{fontWeight: 600}}>COPIED</p>
                </Toast.Body>
            </Toast>
            <Modal size="sm" show={showSendModal} onHide={() => setShowSendModal(false)} aria-labelledby="info-mod-title" className={"pre-form-modal telegram-modal"} centered >
                <Modal.Body>
                    <div className={"stt_modal_header"}>
                        <div style={{width:50}}></div>
                        <div className={"notification_header"} style={{ color: '#aaa', backgroundColor: 'transparent', fontWeight: 600, paddingTop: 15, fontSize: 22 }}>Send</div>
                        <div className={"close_btn"} onClick={() => setShowSendModal(false)}>
                            <i className="fa-solid fa-xmark"></i>
                        </div>
                    </div>
                    <div className={"help-wrapper telegram-wrapper"} style={{ padding: 15  }}>
                        <Form.Control type="text" placeholder="ERC-20" className={"stt-send-input w-80"} required min={0.0} onChange={(e) => setTargetErc(e.target.value)} value={targetErc} style={{width: '100%', backgroundColor: "transparent", padding: 10, background: '#eee', borderColor: 'transparent', marginBottom: 30, marginTop: 50}} />

                        <Form.Control type="text" placeholder="0.0 STT" className={"stt-input w-80"} required min={0.0} onChange={handleRateChange} onFocus={handleFocus} onBlur={handleBlur} value={targetAmount ? targetAmount + ' STT' : ''} style={{width: '100%', backgroundColor: "transparent", padding: 0, textAlign: "center"}} />

                        {maxValue > 0 ? <span className={"minimal-helper"} style={{ color: '#888', marginTop: 15 }}>{!props.withoutWallet ? 1 : ''} - {maxValue}</span> : ''}

                        <Button className="modal-button" style={{ display: 'block', margin: '40px auto 15px' }} onClick={() => handleSend()}>Send</Button>
                    </div>
                </Modal.Body>
            </Modal>
            <div className={"preloader"} style={preloader}>
                <Grid
                    height="80"
                    width="80"
                    color="#ffffff"
                    ariaLabel="grid-loading"
                    radius="12.5"
                    wrapperStyle={{}}
                    wrapperClass=""
                    visible={true}
                />
            </div>
            <Toast onClose={() => window.location.reload()} show={toastCompleteShow} onClick={() => setToastCompleteShow(false)} autohide delay={5000} position={"middle-center"} className={"complete-toast"}>
                <Toast.Body>
                    <i className="fa-solid fa-circle-check" style={{fontSize: '6rem', margin: 20, color: '#96fac5'}}></i>
                    <p style={{fontWeight: 600}}>SUCCESS</p>
                    <p className={"complete-toast-text"}>Please, refresh the page</p>
                </Toast.Body>
            </Toast>
        </React.Fragment>
    )
}

export default Wallet;